import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { avatarUrl } from 'utils/Formatters';
import { linkWithParams } from 'routes';

const FixedBarPlayer = ({ location, locationFrom, player, survey }) => {
  const { t } = useTranslation();
  const bg = { backgroundImage: avatarUrl(player) };
  return (
    <div className='o-navbar cs-bg--sp-black'>
      <div className='o-navbar__wrap row align-middle'>
        <div className='column u-flex align-middle'>
          <Link className='o-sp-button o-sp-button--back'
            to={locationFrom}>
            <i className='sp-icon-arrow-left'></i>&nbsp;&nbsp;&nbsp;{t('nav.exitSurvey')}
          </Link>
        </div>
        <Link to={{pathname: linkWithParams('player', { player_id: player.id, id: survey.parentQuestionnaireId }), state: { from: location }}}
          className='column u-flex text-right align-middle align-right'>
          <div className='u-margin-right--base'>
            <span className='cs-txt--light'>{player.name}</span><br />
            <span className='cs-txt--sp-gray'>{survey.name} {survey.age}</span>
          </div>
          <div style={bg} className='o-avatar o-avatar--small'></div>
        </Link>
      </div>
    </div>
  );
}

FixedBarPlayer.propTypes = {
  location: PropTypes.object.isRequired,
  locationFrom: PropTypes.object.isRequired,
  player: PropTypes.object.isRequired,
  survey: PropTypes.object.isRequired,
}

export default FixedBarPlayer;
